const dropdownValue = {
  Unclassified: 'unclassified',
};

export default dropdownValue;
